import type { ReactElement } from "react";
import { CmtsSecurityLogsContainer } from "../../core/containers/domain/auditsecurityRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsSecurityLogsContainer runtime={props.runtime} />;
}

export default Component;
